import {Component, Input, OnInit} from '@angular/core';
import {TableColumn} from "../../../../@config/interfaces/table-column.interface";
import {MatDialog} from "@angular/material/dialog";
import {CoreService} from "../../../services/core.service";
import {ActivatedRoute, Router} from "@angular/router";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {GlobalService} from "../../../services/global.service";
import {HandleResponseError} from "../../../shared/functions/shared-functions";
import {ToastrService} from "ngx-toastr";
import {PageNumber} from "../../../shared/variables/variables";
import {TranslateService} from "@ngx-translate/core";

@UntilDestroy()
@Component({
  selector: 'app-passed-users-list',
  templateUrl: './passed-users-list.component.html',
  styleUrls: ['./passed-users-list.component.scss']
})
export class PassedUsersListComponent implements OnInit {
  @Input() hasAdd: boolean = true;
  @Input() hasDelete: boolean = false;
  @Input() hasModify: boolean = true;
  menuOpen = false;
  tableData = [];
  tableColumns: TableColumn<any>[] = [
    {
      label: '',
      property: 'selected',
      type: 'checkbox',
      visible: true,
      cssClasses: ['w-6']
    },
    {
      label: 'Reference number',
      property: 'reference_number',
      type: 'number',
      visible: true,
      cssClasses: ['font-medium']
    },
    {
      label: 'Full name',
      property: 'full_name',
      type: 'text',
      visible: true,
      cssClasses: ['font-medium']
    },
    {
      label: 'Email',
      property: 'email',
      type: 'text',
      cssClasses: ['font-medium'],
      visible: true
    },
    {
      label: 'Phone',
      property: 'phone',
      type: 'text',
      cssClasses: ['font-medium'],
      visible: true
    },
    {
      label: 'challenges completed',
      property: 'challenges_completed',
      type: 'number',
      cssClasses: ['font-medium'],
      visible: true
    },
    {
      label: 'Today score',
      property: 'todays_score',
      type: 'number',
      cssClasses: ['font-medium'],
      visible: true
    },
    {
      label: 'Overall score',
      property: 'overall_score',
      type: 'number',
      cssClasses: ['font-medium'],
      visible: true
    },
    {
      label: '',
      property: 'menu',
      type: 'button',
      visible: true,
      cssClasses: ['text-secondary', 'w-10']
    },
  ];
  paginationEvent = {
    pageIndex: 1,
    pageSize: 20,
    previousPageIndex: 0
  };
  queryParams;
  total;
  next_page;

  constructor(private dialog: MatDialog,
              private coreService: CoreService,
              private globalService: GlobalService,
              private router: Router,
              private toastr: ToastrService,
              private translateService: TranslateService,
              private activatedRoute: ActivatedRoute,) {
  }

  ngOnInit() {
    this.tableData = this.activatedRoute.snapshot.data['passed_users'].data;
    this.next_page = this.activatedRoute.snapshot.data['passed_users'].next_page;
    this.total = this.activatedRoute.snapshot.data['passed_users'].total;
    this.handleData();
    this.subscribeToFilter();
  }

  subscribeToFilter() {
    this.globalService.filterChangedSubject.pipe(untilDestroyed(this)).subscribe((value: any) => {
      if (value) {
        this.queryParams = `&${value?.main_category ? 'main_category_id=' + value?.main_category?.id + '&' : ''}${value?.sub_category ? 'sub_category_id=' + value?.sub_category?.id + '&' : ''}`


        if (this.queryParams?.lastIndexOf('&') === this.queryParams?.trim().length - 1) {
          this.queryParams = this.queryParams.substring(0, this.queryParams?.trim().length - 1);
        }
        this.getServerData();
      }
    });
  }

  removeFromPasseUsers(row?: any) {
    this.coreService.getRequest(`admin/update-user-passed/${row?.id}`).pipe(untilDestroyed(this)).subscribe(
      res => {
        this.toastr.success(res?.message);
        const ids = [row?.id]
        this.tableData = this.tableData.filter(x => !ids?.includes(x.id));
      }, error => {
        this.toastr.error(HandleResponseError(error));
      }
    )
  }

  viewCertificate(row?: any) {
    window.open(row?.certificate_url)
  }

  generateCertificate(rows?: any) {
    rows?.forEach(row => {
      this.coreService.getRequest(`admin/generate-user-certificate/${row?.id}`).pipe(untilDestroyed(this)).subscribe(
        res => {
          this.toastr.success(res?.message);
        }, error => {
          this.toastr.error(HandleResponseError(error));
        }
      )
    });
  }

  resetPagination() {
    this.paginationEvent = {
      ...this.paginationEvent,
      pageIndex: PageNumber,
    };
  }

  getServerData(event?) {
    console.log('e', event)
    let pagination = '';
    let searchKeyword = '';
    if (event?.pageIndex !== undefined) {
      this.paginationEvent = {...event};
    } else if (event) {
      searchKeyword = `&search=${event}`;
    } else {
      this.resetPagination();
    }
    pagination = `limit=${this.paginationEvent.pageSize}&page=${this.paginationEvent.pageIndex}`;
    this.coreService.getRequest(`admin/passed-users?${pagination}${searchKeyword}${this.queryParams ? this.queryParams : ''}`).pipe(untilDestroyed(this)).subscribe(
      res => {
        this.tableData = [...res?.data];
        this.handleData();
      }, error => {
        this.toastr.error(HandleResponseError(error));
      }
    )
  }

  handleData() {
    this.tableData?.forEach((item: any) => {
      item.status = item.status === 1 ? this.translateService.instant('ACTIVE') : this.translateService.instant('NOT ACTIVE');
    });
  }
}
